import { makeStyles } from "@material-ui/core/styles";
import SingleAutocompleteSelectField, {
  SingleAutocompleteChoiceType
} from "@saleor/components/SingleAutocompleteSelectField";
import { FormChange } from "@saleor/hooks/useForm";
import { FetchMoreProps } from "@saleor/types";
import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";

import { SellerBrandFormData } from "./SellerListPage";
const useStyles = makeStyles(
  theme => ({
    dropdownWrapper: {
      float: "right",
      marginBottom: theme.spacing(3),
      width: "300px"
    }
  }),
  { name: "DrodownWrapper" }
);

interface SellerBrandDropdownProps {
  sellerDisplayValue: string;
  change: any;
  submit: any;
  brandID: string;
  brands: SingleAutocompleteChoiceType[];
  data: SellerBrandFormData;
  fetchBrands: (query: string) => void;
  fetchMoreBrands?: FetchMoreProps;
  onBrandChange: FormChange;
}

const SellerBrandDropdown: React.FC<SellerBrandDropdownProps> = props => {
  const {
    data: formData,
    brandID,
    brands,
    fetchBrands,
    fetchMoreBrands,
    onBrandChange,
    sellerDisplayValue
  } = props;
  const intl = useIntl();
  const classes = useStyles(props);

  const [firstLoad, setFirstLoad] = useState(true);

  useEffect(() => {
    if (firstLoad && brands && brands.length) {
      setFirstLoad(false);
      if (
        sellerDisplayValue !== "" &&
        brandID !== null &&
        brandID !== undefined
      ) {
        const newEvent = { target: { name: "sellerBrand", value: brandID } };
        onBrandChange(newEvent);
      }
      if (
        brands &&
        brands.length &&
        sellerDisplayValue === "" &&
        brandID === undefined
      ) {
        const newEvent = {
          target: { name: "sellerBrand", value: brands[0].value }
        };
        onBrandChange(newEvent);
      }
    }
  }, [brands, sellerDisplayValue]);

  return (
    <div className={classes.dropdownWrapper}>
      <SingleAutocompleteSelectField
        label={intl.formatMessage({
          defaultMessage: "Seller (Brand)*"
        })}
        name="sellerBrand"
        displayValue={sellerDisplayValue}
        choices={brands}
        disabled={false}
        value={formData.sellerBrand}
        onChange={event => {
          onBrandChange(event);
        }}
        fetchChoices={fetchBrands}
        {...fetchMoreBrands}
      />
    </div>
  );
};
SellerBrandDropdown.displayName = "SellerBrandDropdown";
export default SellerBrandDropdown;
